import React from "react";
import underm from "Assets/images/underm.jpg";
import "./style.scss";
const UnderMaintainence = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div>
        <img
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            left: 0,
            top: 0,
          }}
          src={underm}
          layout="fill"
          alt="Under Maintainence"
        />
      </div>
      <div
        style={{
          backgroundColor: "rgba(0,0,0,0.1)",
          zIndex: 99,
          height: "100vh",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
        }}
      ></div>
      <div
        style={{
          zIndex: 100,
          maxWidth: "990px",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <h1
          style={{
            fontSize: "52px",
            fontFamily: "Gallique",
            marginBottom: "30px",
          }}
        >
          Under Maintainence
        </h1>
        <p
          className="text-center"
          style={{ fontSize: "24px", lineHeight: 1.4 }}
        >
          The prettiest flowers will be blooming soon. For queries and
          suggestion you can contact us on{" "}
          <a className="inline-link-white" href="tel:+13106597700">
            (310) 659-7700
          </a>{" "}
          or email us at:{" "}
          <a className="inline-link-white" href="mailto:info@frenchflorist.com">
            info@frenchflorist.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default UnderMaintainence;
